import { Component, ContentChild, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { BackgroundImageService } from '../../data-access/services/background-image.service';
import { UserStore } from '../../data-access/stores/user.store';
import { Router } from '@angular/router';
import { Roles, UserAttributes } from '../../../authentication/data-access/models/auth.model';
import { AuthService } from '../../../authentication/data-access/services/auth.service';
import { Observable } from "rxjs";

@Component({
    selector: 'app-landing-screen',
    templateUrl: './landing-screen.component.html',
    styleUrl: './landing-screen.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class LandingScreenComponent {
  @ContentChild('adminContentProjection') adminContent: ElementRef | undefined;
  @ContentChild('studentContentProjection') studentContent: ElementRef | undefined;
  userRole!: Roles;
  isLoggedIn$: Observable<boolean> = this.authService.isLoggedIn$;
  userDetails!: UserAttributes;
  isOverviewer: boolean = false;
  isStudent: boolean = false;
  url: string = '';
   hasAdminContent: boolean = false;
   hasStudentContent: boolean = false;
  @Input() backgroundImageUrl: string = '';
   rolesEnum: typeof Roles = Roles;
  constructor(
    private backgroundImageService: BackgroundImageService,
    private userStore: UserStore,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.backgroundImageUrl = this.backgroundImageService.getRandomBackgroundImage();
    this.url = this.router.url;
    this.isOverviewer = this.userStore.hasRole([this.rolesEnum.OVERVIEWER]);
    this.isStudent = this.userStore.hasRole([this.rolesEnum.STUDENT]);
    this.userStore.get().subscribe((user) => {
      this.userDetails = user;
    });
  }

  ngAfterContentInit(): void {
    this.hasAdminContent = !!this.adminContent;
    this.hasStudentContent = !!this.studentContent;
  }
  successScreenRoute(): boolean {
    if (
      this.router.url.includes('legal/agreements/privacy-policy') ||
      this.router.url.includes('legal/agreements/terms-conditions') ||
      this.router.url.includes('/unauthorised') ||
      this.router.url.includes('/forbidden') ||
      this.router.url.includes('/maintenance') ||
      this.router.url.includes('/not-found')
    ) {
      return true;
    }
    return false;
  }
}
